export const getReferrerPath = () =>
  document.referrer ? new URL(document.referrer).pathname : 'unknown'
